// {{WORKTREE_ROOT}}/picosponsorconsole/app/components/states/NotFound.tsx
// PLAN2 WP10 — a real 404 body, usable standalone (app/routes/$.tsx) or embedded inside the authenticated shell.
import { DesignLink } from "@picosponsor/design";
import { useT } from "~/utils/locale";
import { TESTIDS } from "~/utils/testids";

export function NotFound({ embedded = false }: { embedded?: boolean }) {
  const t = useT();
  return (
    <div className={embedded ? "flex flex-col items-start gap-3 px-7 py-10" : "flex min-h-screen flex-col items-start justify-center gap-3 px-10"} data-testid={TESTIDS.states.notFound}>
      <h1 className="display m-0 text-30 leading-0.95 tracking-tight-30">{t("states", "not-found-title")}</h1>
      <p className="m-0 text-15 text-dim">{t("states", "not-found-body")}</p>
      <DesignLink href="/" className="text-14 font-bold text-accent" data-testid={TESTIDS.states.backHome}>{t("states", "back-home")}</DesignLink>
    </div>
  );
}
